import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const Header: React.FC = () => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell colSpan={2}>{i18n.t('employee_form.full_name')}</Table.HeadCell>
        <Table.HeadCell>{i18n.t('job_catalog.level')}</Table.HeadCell>
        <Table.HeadCell>{i18n.t('employee_form.hire_date')}</Table.HeadCell>
        <Table.HeadCell colSpan={2}>{i18n.t('common.manager')}</Table.HeadCell>
        <Table.HeadCell />
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
